export const CUSTOMER_MUTATION_TYPES = {
	SET_CUSTOMER: "SET_CUSTOMER",
	SET_BILLING: "SET_BILLING",
	SET_CUSTOMER_PRODUCT: "SET_CUSTOMER_PRODUCT"
} as const;
